import { BaseService } from '@/services/common/base.service'
import type {
  FeedbackDto,
  CreateFeedbackInput,
  GetFeedbackListInput,
  AcceptFeedbackInput,
  ReplyFeedbackInput,
  PagedResultDto
} from './models'

/**
 * 意见反馈服务
 */
export class FeedbackService extends BaseService {
  protected readonly baseUrl = '/api/app/feedback'

  /**
   * 用户提交反馈
   */
  async create(input: CreateFeedbackInput): Promise<FeedbackDto> {
    return await this.post<FeedbackDto>('', input)
  }

  /**
   * 获取我的反馈列表
   */
  async getMyFeedbacks(input: GetFeedbackListInput = {}): Promise<PagedResultDto<FeedbackDto>> {
    return await this.get<PagedResultDto<FeedbackDto>>('/my-feedbacks', input)
  }

  /**
   * 获取单个反馈详情
   */
  async getDetail(id: string): Promise<FeedbackDto> {
    return await this.get<FeedbackDto>(`/${id}`)
  }

  /**
   * 获取所有反馈列表（管理员）
   */
  async getList(input: GetFeedbackListInput = {}): Promise<PagedResultDto<FeedbackDto>> {
    return await this.get<PagedResultDto<FeedbackDto>>('', input)
  }

  /**
   * 采纳反馈（管理员）
   */
  async accept(id: string, input: AcceptFeedbackInput): Promise<FeedbackDto> {
    return await this.post<FeedbackDto>(`/${id}/accept`, input)
  }

  /**
   * 回复反馈（管理员）
   */
  async reply(id: string, input: ReplyFeedbackInput): Promise<FeedbackDto> {
    return await this.post<FeedbackDto>(`/${id}/reply`, input)
  }

  /**
   * 获取今日剩余反馈次数
   */
  async getRemainingQuota(): Promise<number> {
    return await this.get<number>('/remaining-quota')
  }
}

// 导出单例
export const feedbackService = new FeedbackService()

// 导出类型
export * from './models'
